import { render, staticRenderFns } from "./AnimateOnScrollPage.vue?vue&type=template&id=f3384b38&"
import script from "./AnimateOnScrollPage.vue?vue&type=script&lang=ts&"
export * from "./AnimateOnScrollPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports